import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Ripple from "../Ripple";
import { RadioProps } from "./PropsType";

export default function Radio(props: RadioProps) {
  const { value, children, className, disabled, disableRipple, name } = props;
  const [checked, setChecked] = useState(!!props.defaultChecked);
  const styleClass = classNames(
    "Radio",
    {
      "Radio-active": checked,
      "Radio-disabled": disabled,
    },
    className
  );

  const  handleInputChange = () => {
    if (props.onChange) {
      props.onChange({
        value,
        originalEvent: event,
      });
    }
  };

  useEffect(() => {
    setChecked(!!props.checked);
  }, [props.checked]);

  return (
    <label className={styleClass}>
      <input
        type="radio"
        disabled={disabled}
        name={name}
        checked={checked}
        onChange={handleInputChange}
      />
      <div className="Radio-icon">
        <svg className="Radio-noChecked" focusable="false" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        <svg className="Radio-checked" focusable="false" viewBox="0 0 24 24">
          <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
        {!disableRipple ? <Ripple centerMode={true} size="sm" /> : null}
      </div>
      <div className="Radio-inner">{children}</div>
    </label>
  );
}
